import { useSelector } from 'react-redux';

import type { RootState } from '../../../../../../store';

export default function useTreatmentPlanV3MedicationPageState() {
  const medicationPage = useSelector((state: RootState) => state.treatmentPlanV3.medicationPage);
  const medications = medicationPage?.medications ?? [];
  const noMedication = medicationPage?.no_medication ?? false;
  const hasLoaded = medicationPage !== null;
  const hasLoadError = useSelector(
    (state: RootState) => state.treatmentPlanV3.medicationPageError != null,
  );
  const medicationPageLoading = useSelector(
    (state: RootState) => state.treatmentPlanV3.medicationPageLoading,
  );
  // Idle (fetch not started) and in-flight both count as loading so the form stays gated.
  const isLoading = medicationPageLoading || (!hasLoaded && !hasLoadError);
  const isSaving = useSelector(
    (state: RootState) =>
      state.treatmentPlanV3.createMedicationLoading ||
      state.treatmentPlanV3.updateMedicationLoading ||
      state.treatmentPlanV3.deleteMedicationLoading ||
      state.treatmentPlanV3.deleteAllMedicationsLoading ||
      state.treatmentPlanV3.setNoMedicationLoading,
  );
  // The bulk operations (delete all / toggle "no medication") must lock the checkbox and
  // list fields and hold the confirm dialog open, so they are exposed on their own rather
  // than only feeding the list progress bar via `isSaving`.
  const isBulkSaving = useSelector(
    (state: RootState) =>
      state.treatmentPlanV3.deleteAllMedicationsLoading ||
      state.treatmentPlanV3.setNoMedicationLoading,
  );

  return { medications, noMedication, isLoading, hasLoaded, hasLoadError, isSaving, isBulkSaving };
}
